import { PaymentMethods } from "../enums/payment-methods";
import { Payment } from "../models/Payment";
import { Practice } from "../models/Practice";
import { hasPaymentAuthorisationExpired } from "./has-payment-authorisation-expired";

export function canPaymentBeCancelled(payment: Payment, practice: Practice): boolean {
    if (practice.paymentMethod == PaymentMethods.PROVET_PAY) {
        return false;
    }

    if (payment.paidAt) {
        return false;
    }

    if (payment.cancelledAt) {
        return false;
    }

    if (payment.refundOfId) {
        return false;
    }

    if (payment.expiresAt < new Date()) {
        return false;
    }

    if (hasPaymentAuthorisationExpired(payment)) {
        return false;
    }

    return true;
}